import { useCallback, useState } from "react";
import { getUsers } from "../../../components/users/functions";
import { useStableSearch } from "../../hooks/useStableSearch";

const DEFAULT_FILTERS = {
  q: "",
  admin: false,
  partner: false,
};

function normalizeUsers(data) {
  if (!Array.isArray(data)) {
    return [];
  }
  return data.map((item) => ({
    ...item,
    createdAt: item.createdAt ? new Date(item.createdAt) : null,
    birth: item.birth ? new Date(item.birth) : null,
  }));
}

export function useUsersSearch(user, initialFilters) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // initialFilters: presets vindos de navegação (ex.: busca de cliente da Home).
  const [filters, setFilters] = useState({ ...DEFAULT_FILTERS, ...initialFilters });

  const runSearch = useCallback(async ({ token, filters: activeFilters, isCurrent }) => {
    setLoading(true);
    setError(null);

    const { q, admin, partner } = activeFilters;
    const data = await getUsers(token, undefined, undefined, undefined, undefined, admin, partner, q);

    if (!isCurrent()) {
      return;
    }

    if (data?.type === "error") {
      setError(data);
      setUsers([]);
    } else if (data?.type === "success") {
      setUsers(normalizeUsers(data.data));
    } else {
      setUsers(normalizeUsers(data));
    }

    setLoading(false);
  }, []);

  const search = useStableSearch(user?.token, filters, runSearch);
  const refresh = useCallback(() => search(), [search]);

  return { users, loading, error, filters, setFilters, search, refresh };
}
